import RadioButton from '@components/RadioButton';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import FilterContext from './context/FilterContext';

function SortItems() {
    const { sortItems, sort, setSort } = useContext(FilterContext);
    const { t } = useTranslation('common');
    if (sortItems) {
        return (
            <Fragment>
                <Row spacing={4}>
                    <Text size='lg' fontWeight='bold'>{t('filter.sort')}</Text>
                    <Text color={colors.gray6} fontWeight='medium'>{t('filter.singleSelect')}</Text>
                </Row>
                <RadioButton
                    // @ts-ignore
                    options={sortItems}
                    // @ts-ignore
                    value={sort}
                    onChange={(v) => {
                        // @ts-ignore
                        setSort?.(v);
                    }} />
            </Fragment>
        );
    }
    return (<Fragment/>);
}

export default SortItems;
